import { useTranslation } from '@frontend/i18n';
import { CheckboxField, useControlledField } from '@frontend/design-system';
import { useCompactTableContext } from '../../../context/compact-table-context';

export const CompactTableSelectAllRows = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { toggleSelectAllRows, areAllRowsSelected, tableId, data, selectedRows, selectableRows, isSelectable } =
    useCompactTableContext();

  const totalRowCount = data.length;
  const selectedCount = selectedRows.length;
  const selectableRowCount = selectableRows.length;
  const hasSomeSelected = selectedCount > 0;
  const hasDisabledRows = totalRowCount > selectableRowCount;

  const checkboxProps = useControlledField({
    type: 'checkbox',
    value: hasSomeSelected,
    onChange: toggleSelectAllRows,
  });
  const checkboxFieldLabel = hasSomeSelected
    ? t('Selected {{selected}} of {{total}}', { selected: selectedCount, total: totalRowCount })
    : hasDisabledRows
    ? t('Select All Available')
    : t('Select All');

  if (!isSelectable) return null;

  return (
    <CheckboxField
      name={`${tableId}-select-all`}
      label={checkboxFieldLabel}
      {...checkboxProps}
      indeterminate={!areAllRowsSelected}
      className={className}
      disabled={selectableRowCount === 0}
    />
  );
};
